import { Fragment } from "react";
import _ from "lodash";

import ConditionDesignerLightCode from "./ConditionDesignerLightCode";

import { getLabel, getLanguage } from "../../tools/Dictionary";
import { MdEdit, MdDelete } from "react-icons/md";

const ConditionDesignerItem = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  //const Step = props.Step;
  const Variable = props.Variable;
  const Error = props.Error;
  const Loading = props.Loading;
  const GroupIndex = props.GroupIndex;
  const ConditionIndex = props.ConditionIndex;
  const OnChangeValue = props.OnChangeValue;
  const OnClickUserVariable = props.OnClickUserVariable;
  const OnChangeGlobalVariable = props.OnChangeGlobalVariable;
  const OnChangeFormula = props.OnChangeFormula;
  //const OnClickConversion = props.OnClickConversion;
  const OnClickRemoveCondition = props.OnClickRemoveCondition;
  const OnChangeSensorVariable = props.OnChangeSensorVariable;
  const OnChangeTolerance = props.OnChangeTolerance;
  const OnChangeOperator = props.OnChangeOperator;
  const OnChangeType = props.OnChangeType;
  const ThrowError = props.ThrowError;


  //Variable
  const typeValue = [
    "literal",
    "userVariable",
    "globalVariable",
    "formula"
   ]
  const operator = [
    "eq",
    "ne",
    "gt",
    "gte",
    "lt",
    "lte",
    "in",
    "notin"
  ]

  const onChangeValueType = (e, _property) => {

    const type = e.target.value;

    let tempData = _.cloneDeep(Data);

    try {

      //tempData[_property] = {};
      tempData = {};

      switch (type)
      {
        case "literal":
          tempData.type = "literal";
          tempData.data = "";
          break;
        case "userVariable":
          tempData.type = "userVariable";
          tempData.processStep = undefined;
          tempData.processStepTitle = "";
          tempData.component = undefined;
          tempData.componentName = "";
          tempData.option = [];
          tempData.code = undefined;
          break;
        case "globalVariable":
          tempData.type = "globalVariable";
          tempData.variable = undefined;
          tempData.variableName = "";
          break;
        case "formula":
          tempData.type = "formula";
          tempData.data = "";
          tempData.variable = [];
          break;
        default:
          break;

      }

      OnChangeType(tempData, GroupIndex, ConditionIndex, _property);


    }catch(err){

      ThrowError(err);

    }

  };

  const onChangeData = (e, _property) => {

    let data = e.target.value;

    try{

      if (data && data.length > 30) return;

      OnChangeValue(data, GroupIndex, ConditionIndex, _property);

    }catch(err){

      ThrowError(err);

    }


  };

  const onChangeDataCustom = (_data, _property) =>
  {

    try
    {

      if (!_data) return;

      OnChangeValue(_data, GroupIndex, ConditionIndex, _property);

    } catch (err)
    {

      ThrowError(err);

    }


  };


  const onChangeOperator = (e) => {

    try
    {

      // let tempData = _.cloneDeep(Data);

      // tempData["operator"] = e.target.value;

      OnChangeOperator(e.target.value, GroupIndex, ConditionIndex);

    } catch (err)
    {

      ThrowError(err);

    }


  };



  const onDisplayValue = (_property = "") => {

    
    switch (Data[_property].type) {
      case "literal":

        if (_property == "valueRight" && Data["valueLeft"].type == "userVariable" && Data["valueLeft"].componentCode == "LightCode"){
          return (
            <ConditionDesignerLightCode
              Value={Data[_property].data}
              Data={Data["valueLeft"].componentData}
              Access={Access}
              ReadOnly={ReadOnly}
              OnChangeData={(_value) => onChangeDataCustom(_value, _property)}
            />
          );
        }

        if (_property == "valueRight" && Data["valueLeft"].type == "userVariable" && Data["valueLeft"].option && Data["valueLeft"].option.length > 0)
        {
          return (
            <select
              value={Data[_property].data}
              className={"page_select_input " + (Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_data"] ? "auth_fill_row_input_error " : "")}
              onChange={(e) => onChangeData(e, _property)}
              style={{ width: "200px", textAlign: "center", color: "black" }}
              disabled={!Access.canWrite || Loading || ReadOnly}
              title={Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_data"]}
            >
              <option value hidden style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Choose a value")}...</option>
              {Data["valueLeft"].option.map((o, index) => (
                <option key={index} value={o.value} style={{ textAlign: "center", color: "black" }}>
                  {o.label[getLanguage()] || o.label["EN"] || ""}
                </option>
              ))}
            </select>
          );
        }

        return (
        <Fragment>
            <div className="conditiondesigner_samerow">
              <input
                className={"page_text_input " + (Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_data"] ? "page_modal_body_col_input_error" : "")}
                value={Data[_property].data || ""}
                onChange={(e) => onChangeData(e, _property)}
                type="text"
                placeholder={getLabel("ConditionDesigner", "Input a value")}
                style={{ width: "100%" }}
                disabled={!Access.canWrite || Loading || ReadOnly}
                title={Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_data"] || ""}
              />
              {_property == "valueRight" && Data["valueLeft"].type == "userVariable" && Data["valueLeft"].componentData && Data["valueLeft"].componentData.temperatureUnit &&
                <div className="conditiondesigner_temp_unit">
                  °C
                </div>
              }
              {_property == "valueRight" && Data["valueLeft"].type == "userVariable" && Data["valueLeft"].componentCode == "Superheat" &&
                <div className="conditiondesigner_temp_unit">
                  °F
                </div>
              }
            </div>
            {Error["valueTypeData"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {Error["valueTypeData"]}
              </div>
            }
        </Fragment>
        );
      case "userVariable": 
        if (Data[_property].processStep){
          return (
            <div className="conditiondesigner_item_display_cont" >
              <div className="conditiondesigner_item_display_group_value" style={{width: "100%"}}>
                {(Access.canWrite && !ReadOnly) &&
                  <div className="page_button_round" style={{ marginRight: "10px", width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px" }} title={getLabel("ConditionDesigner", "Choose a variable")} onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, _property)}>
                    <MdEdit />
                  </div>
                }
                <div className="conditiondesigner_item_variable_label" title={Data[_property].processStepTitle + "." + Data[_property].componentName}>
                  {Data[_property].processStepTitle}.{Data[_property].componentName}
                </div>
              </div>
            </div>
          );
        }else{
          return (
            <Fragment>
              <input
                type="button"
                className={"page_button " + (Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_variable"] ? "conditiondesigner_cond_button_error" : "")} 
                value={getLabel("ConditionDesigner", "Choose a variable")}
                style={{ width: "200px", height: "30px" }}
                onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, _property)}
                disabled={Loading}
                title={Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_variable"]}
              />
            </Fragment>
          );
        }
      case "globalVariable":
        return (
          <select
            value={Data[_property].variable}
            className={"page_select_input " + (Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_global"] ? "auth_fill_row_input_error " : "")}
            onChange={(e) => OnChangeGlobalVariable(e, GroupIndex, ConditionIndex, _property)}
            style={{ width: "200px", textAlign: "center", color: "black" }}
            disabled={!Access.canWrite || Loading || ReadOnly}
            title={Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_global"]}
          >
            <option value hidden style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Choose a variable")}...</option>
            {Variable.filter(v => v.variableTypeCode != "table" && v.variableTypeCode != "sensor").map((v, index) => (
              <option key={index} value={v._id} style={{ textAlign: "center", color: "black" }}>
                {v.name}
              </option>
            ))}
          </select>
        )  
      case "formula":
        return (
          <div className="conditiondesigner_item_display_cont" style={{ width: "100%" }} >
            <div className="conditiondesigner_item_display_group_value" style={{ width: "100%" }}>
              {(Access.canWrite && !ReadOnly) &&
                <div className="page_button_round" style={{ marginRight: "10px", width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px" }} title={getLabel("ConditionDesigner", "Edit the formula")} onClick={() => OnChangeFormula(GroupIndex, ConditionIndex, _property)}>
                  <MdEdit />
                </div>
              }
              <input
                className={"page_text_input " + (Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_data"] ? "page_modal_body_col_input_error" : "")}
                value={Data[_property].data || ""}
                type="text"
                style={{ width: "100%" }}
                disabled={true}
                title={Error[GroupIndex + "_" + ConditionIndex + "_" + _property + "_data"] || ""}
              />
              </div>
          </div>
        );
      default:
        return (
          <Fragment>
            {getLabel("ConditionDesigner", "Choose the variable type")}
          </Fragment>
        );
      }

    

  };



  //IF
  if (Data.type == "if")
    return (
      <div className="conditiondesigner_cond_item" key={GroupIndex + "_" + ConditionIndex}> 
        <div className="conditiondesigner_value">
          {(Access.canWrite && !ReadOnly) &&
            <div className="page_button_round conditiondesigner_button_delete"  title={getLabel("ConditionDesigner", "Remove condition")} onClick={() => OnClickRemoveCondition(GroupIndex, ConditionIndex)}>
              <MdDelete />
            </div>
          }
          <div className="conditiondesigner_value_type" style={{width: (IsDesktop ? "30%" : "100%")}}>
            <select
              value={Data.valueLeft.type}
              className={"page_select_input " + (Error["valueLeftType"] ? "auth_fill_row_input_error " : "")}
              onChange={(e) => onChangeValueType(e, "valueLeft")}
              style={{ width: "200px", textAlign: "center", color: "black" }}
              disabled={!Access.canWrite || Loading || ReadOnly}
            >
              <option value hidden style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Select type")}...</option>
              {typeValue.map((t, index) => (
                <option key={index} value={t} style={{ textAlign: "center", color: "black" }}>
                  {getLabel("ConditionDesigner", t)}
                </option>
              ))}
            </select>
          </div>
          <div className="conditiondesigner_value_value" style={{ width: (IsDesktop ? "65%" : "100%") }}>
            {onDisplayValue("valueLeft")}        
          </div>
        </div>
        {Data.valueLeft.type && 
        <div className="conditiondesigner_operator">
          <select
            value={Data.operator}
              className={"page_select_input " + (Error[GroupIndex + "_" + ConditionIndex + "_operator"] ? "auth_fill_row_input_error " : "")}
              onChange={onChangeOperator}
            style={{ width: "200px", textAlign: "center", color: "black" }}
            disabled={!Access.canWrite || Loading || ReadOnly}
          >
              <option value="" hidden style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Select operator")}...</option>
            {operator.map((o, index) => (
              <option key={index} value={o} style={{ textAlign: "center", color: "black" }}>
                {getLabel("ConditionDesigner", o)}
              </option>
            ))}
          </select>            
        </div>
        }
        {Data.valueLeft.type && Data.operator &&
          <div className="conditiondesigner_value" >
            <div className="conditiondesigner_value_type" style={{ width: (IsDesktop ? "30%" : "100%") }}>
              <select
                value={Data.valueRight.type}
                className={"page_select_input " + (Error["valueRightType"] ? "auth_fill_row_input_error " : "")}
                onChange={(e) => onChangeValueType(e, "valueRight")}
                style={{ width: "200px", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || Loading || ReadOnly}
              >
                <option value hidden style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Select type")}...</option>
                {typeValue.map((t, index) => (
                  <option key={index} value={t} style={{ textAlign: "center", color: "black" }}>
                    {getLabel("ConditionDesigner", t)}
                  </option>
                ))}
              </select>
            </div>
            <div className="conditiondesigner_value_value" style={{ width: (IsDesktop ? "65%" : "100%") }}>
              {onDisplayValue("valueRight")}
            </div>
          </div>
        }
      </div>
    );


  //SENSOR
  if (Data.type == "sensor")
    return (
      <div className="conditiondesigner_cond_item" key={GroupIndex + "_" + ConditionIndex}> 
        <div className="conditiondesigner_value">
          {(Access.canWrite && !ReadOnly) &&
          <div className="page_button_round conditiondesigner_button_delete" title={getLabel("ConditionDesigner", "Remove condition")} onClick={() => OnClickRemoveCondition(GroupIndex, ConditionIndex)}>
            <MdDelete />
          </div>
          }
          <div className="conditiondesigner_value_value" style={{ width: (IsDesktop ? "100%" : "100%") }}>
            <div className="conditiondesigner_item_display_cont">
              <div className="conditiondesigner_item_display_group_label">
                <div className="conditiondesigner_item_variable_caption">
                  {getLabel("ConditionDesigner", "Temperature")} :
                </div>
              </div>
              <div className="conditiondesigner_item_display_group_value">
                {Data["valueLeft"].processStep ? (
                  <Fragment>
                    {(Access.canWrite && !ReadOnly) &&
                      <div className="conditiondesigner_item_display_group" style={{width: "20%"}}>
                        <div className="page_button_round" style={{ marginRight: "10px", width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px" }} title={getLabel("ConditionDesigner", "Choose a variable")} onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, "valueLeft")}>
                          <MdEdit />
                        </div>
                      </div>
                    }
                    <div className="conditiondesigner_item_variable_label" title={Data["valueLeft"].processStepTitle + "." + Data["valueLeft"].componentName}>
                      {Data["valueLeft"].processStepTitle}.{Data["valueLeft"].componentName}
                    </div>
                  </Fragment>
                ) : (
                  <input
                    type="button"
                    className={"page_button " + (Error[GroupIndex + "_" + ConditionIndex + "_valueLeft_variable"] ? "conditiondesigner_cond_button_error" : "")} 
                    value={getLabel("ConditionDesigner", "Choose a variable")}
                    style={{ width: "200px", height: "30px" }}
                    onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, "valueLeft")}
                    disabled={!Access.canWrite || Loading || ReadOnly}
                    title={Error[GroupIndex + "_" + ConditionIndex + "_valueLeft_variable"]}
                  />
                )}
              </div>
              <div className="conditiondesigner_item_display_group">
                <div className="conditiondesigner_item_variable_caption">
                  {getLabel("ConditionDesigner", "Resistance")} :
                </div>
              </div>
              <div className="conditiondesigner_item_display_group_value">
                {Data["valueRight"].processStep ? (
                  <Fragment>
                    {(Access.canWrite && !ReadOnly) &&
                      <div className="conditiondesigner_item_display_group" style={{ width: "20%" }}>
                        <div className="page_button_round" style={{ marginRight: "10px", width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px" }} title={getLabel("ConditionDesigner", "Choose a variable")} onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, "valueRight")}>
                          <MdEdit />
                        </div>
                      </div>
                    }
                    <div className="conditiondesigner_item_variable_label" title={Data["valueRight"].processStepTitle + "." + Data["valueRight"].componentName}>
                      {Data["valueRight"].processStepTitle}.{Data["valueRight"].componentName}
                    </div>
                  </Fragment>
                ) : (
                  <input
                    type="button"
                      className={"page_button " + (Error[GroupIndex + "_" + ConditionIndex + "_valueRight_variable"] ? "conditiondesigner_cond_button_error" : "")} 
                    value={getLabel("ConditionDesigner", "Choose a variable")}
                    style={{ width: "200px", height: "30px" }}
                    onClick={() => OnClickUserVariable(GroupIndex, ConditionIndex, "valueRight")}
                    disabled={Loading}
                    title={Error[GroupIndex + "_" + ConditionIndex + "_valueRight_variable"]}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="conditiondesigner_value" style={{marginTop: "4px"}}>
          <div className="conditiondesigner_item_display_group_label">
            <div className="conditiondesigner_item_variable_caption">
              {getLabel("ConditionDesigner", "Sensor variable")} :
            </div>
          </div>
          <div className="conditiondesigner_item_display_group_value">
            <select
              value={Data["sensor"].variable}
              className={"page_select_input " + (Error[GroupIndex + "_" + ConditionIndex + "_sensor"] ? "auth_fill_row_input_error " : "")}
              onChange={(e) => OnChangeSensorVariable(e, GroupIndex, ConditionIndex)}
              style={{ width: "200px", textAlign: "center", color: "black" }}
              disabled={!Access.canWrite || Loading || ReadOnly}
              title={Error[GroupIndex + "_" + ConditionIndex + "_sensor"]}
            >
              <option value hidden style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Choose a variable")}...</option>
              {Variable.filter(v => v.variableTypeCode == "sensor").map((v, index) => (
                <option key={index} value={v._id} style={{ textAlign: "center", color: "black" }}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>
          <div className="conditiondesigner_item_display_group_label">
            <div className="conditiondesigner_item_variable_caption">
              {getLabel("ConditionDesigner", "Tolerance")} :
            </div>
          </div>
          <div className="conditiondesigner_item_display_group_value" style={{width: "200px"}}>
            <input
              className={"page_text_input " + (Error[GroupIndex + "_" + ConditionIndex + "_sensor_tolerance"] ? "page_modal_body_col_input_error" : "")}
              value={Data["sensor"].tolerance || ""}
              onChange={(e) => OnChangeTolerance(e, GroupIndex, ConditionIndex)}
              type="text"
              style={{ width: "100px" }}
              disabled={!Access.canWrite || Loading || ReadOnly}
              title={Error[GroupIndex + "_" + ConditionIndex + "_sensor_tolerance"]}
            />
          </div>
        </div>
      </div>
    );

  return null;

};

export default ConditionDesignerItem;